export const money = (value, currency = 'USD') => {
  if (value === null || value === undefined || value === '') return 'Unavailable';
  const amount = Number(value);
  if (!Number.isFinite(amount)) return 'Unavailable';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency, maximumFractionDigits: 2 }).format(amount);
};

export const shares = (value) => {
  if (value === null || value === undefined || value === '') return 'Unavailable';
  const amount = Number(value);
  if (!Number.isFinite(amount)) return 'Unavailable';
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 6 }).format(amount);
};

export const portfolioProblem = (error) => {
  const reason = error?.response?.data?.detail?.reason;
  if (reason === 'oauth_not_connected') return 'Connect Alpaca Paper in Account settings to see your brokerage portfolio.';
  if (reason === 'oauth_authorization_failed' || reason === 'oauth_connection_changed') return 'Your Alpaca Paper connection needs to be renewed. No portfolio balance was inferred.';
  if (reason === 'provider_account_identity_changed') return 'The connected Alpaca account changed. Reconnect and verify the account before viewing balances.';
  if (reason === 'provider_rate_limited') return 'Alpaca is limiting requests. Try again shortly; the portfolio has not been shown as empty.';
  return 'Alpaca portfolio data is temporarily unavailable. Try again; no balance or holdings were inferred.';
};

export const activityLabel = (activity) => {
  const labels = {
    fill: 'Trade fill', dividend: 'Dividend', deposit_or_transfer: 'Deposit or cash transfer',
    withdrawal: 'Withdrawal', fee: 'Fee', corporate_action: 'Corporate action', other: 'Other activity',
  };
  return labels[activity?.category] || 'Other activity';
};

export const equityChartPoints = (points, width = 600, height = 160) => {
  const values = (points || []).map((point) => Number(point.equity)).filter(Number.isFinite);
  if (values.length < 2) return '';
  const min = Math.min(...values);
  const max = Math.max(...values);
  const spread = max - min || 1;
  return values.map((value, index) => `${Math.round((index / (values.length - 1)) * width)},${Math.round(height - ((value - min) / spread) * height)}`).join(' ');
};
